export default __webpack_public_path__ + "static/media/title_sp.8f007831.png";